var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobe01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1245_1161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 9.99996H18.3337M1.66699 9.99996C1.66699 14.6023 5.39795 18.3333 10.0003 18.3333M1.66699 9.99996C1.66699 5.39759 5.39795 1.66663 10.0003 1.66663M18.3337 9.99996C18.3337 14.6023 14.6027 18.3333 10.0003 18.3333M18.3337 9.99996C18.3337 5.39759 14.6027 1.66663 10.0003 1.66663M10.0003 1.66663C12.0847 3.94859 13.2693 6.90999 13.3337 9.99996C13.2693 13.0899 12.0847 16.0513 10.0003 18.3333M10.0003 1.66663C7.91593 3.94859 6.73137 6.90999 6.66699 9.99996C6.73137 13.0899 7.91593 16.0513 10.0003 18.3333",
    stroke: "#667085",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1245_1161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe01);
export default __webpack_public_path__ + "static/media/globe-01.ee77ba36c5638cf6d338fd3afd1974ad.svg";
export { ForwardRef as ReactComponent };